import { useQueryClient } from 'react-query';
import useHttpQuery from '@actions/services/firestore/browser/useHttpQuery';
import useHttpMutation from '@actions/services/firestore/browser/useHttpMutation';
import type { ListAdminOrganizationsResponse, UseListAdminOrganizationsResult } from './types';

export const ADMIN_ORGANIZATIONS_QUERY_KEY = 'admin-organizations';

const useListAdminOrganizations = (): UseListAdminOrganizationsResult => {
    const queryClient = useQueryClient();
    const { data, isLoading, error, refetch } = useHttpQuery<ListAdminOrganizationsResponse>({
        pathname: '/admin/organizations',
        method: 'GET',
        key: ADMIN_ORGANIZATIONS_QUERY_KEY,
    });
    const { mutate, isLoading: isRefreshingFromStripe } = useHttpMutation<
        undefined,
        ListAdminOrganizationsResponse
    >({
        method: 'GET',
        pathname: '/admin/organizations?stripeRead=live',
        onSuccess: response => {
            queryClient.setQueryData<ListAdminOrganizationsResponse>(
                ADMIN_ORGANIZATIONS_QUERY_KEY,
                response
            );
        },
    });

    return {
        organizations: data?.data || [],
        billingFreshness: data?.billingFreshness ?? null,
        isLoadingOrganizations: isLoading,
        isRefreshingFromStripe,
        error: error || undefined,
        refetch,
        refreshFromStripe: () => {
            mutate({});
        },
    };
};

export default useListAdminOrganizations;
